import React from 'react';
import { Routes as RouteList, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';

import Main from '../Main';
import Target from '../Target';
import DashboardEditor from '../DashboardEditor';
import CustomerEditor from '../CustomerEditor';
import UserEditor from '../UserEditor';
import About from '../About';

const Routes = () => (
  // Most specific paths at the top.
  <RouteList>
    <Route path="/target/:targetId" element={<ProtectedRoute><Target/></ProtectedRoute>}/>
    <Route path="/dashboard/:dashboardId" element={<ProtectedRoute><DashboardEditor/></ProtectedRoute>}/>
    <Route path="/customer/:customerId" element={<ProtectedRoute><CustomerEditor/></ProtectedRoute>}/>
    <Route path="/user/:userId" element={<ProtectedRoute><UserEditor/></ProtectedRoute>}/>
    <Route path="/dashboard" element={<ProtectedRoute><DashboardEditor/></ProtectedRoute>}/>
    <Route path="/about" element={<ProtectedRoute><About/></ProtectedRoute>}/>
    <Route path="/" element={<Main/>}/>
    <Route path="*" element={<Navigate to="/" replace/>}/>
  </RouteList>
);

export default Routes;
